import { FC, SVGProps } from 'react';

import { LoaderIcon } from '@/assets/icons';
import { cn } from '@/utils/tailwind';

export const Spinner: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <LoaderIcon
      className={cn('animate-spin size-5 text-custom-warm-grey-200', className)}
      {...props}
    />
  );
};
